import { Component, OnInit, Input } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { NotificationService } from '@app/core/notifications/services/notification.service';
import { SalesOrderPullNotificationsComponent } from 'v2/modules/sales-order/components/sales-order-pull-notifications/sales-order-pull-notifications.component';
import { DialogConfig } from 'v2/modules/shared/configs/dialog.config';

import { CreatedPicklistPerOrderNotificationsSummaryComponent } from '../created-picklist-per-order-notifications-summary/created-picklist-per-order-notifications-summary.component';

@Component({
  selector: 'lum-notification-dropout',
  templateUrl: './notification-dropout.component.html',
  styleUrls: ['./notification-dropout.component.scss'],
})
export class NotificationDropoutComponent implements OnInit {
  // Show dot on top of the icon
  @Input() dot :boolean;

  // Show pulse on icon
  @Input() pulseLight :boolean;

  // Set icon class name
  @Input() icon :string = 'flaticon2-bell-alarm-symbol';
  @Input() iconType :'' | 'success';

  // Set true to icon as SVG or false as icon class
  @Input() useSVG :boolean;

  // Set bg image path
  @Input() bgImage :string;

  // Set skin color, default to light
  @Input() skin :'light' | 'dark' = 'light';

  @Input() type :'brand' | 'success' = 'success';

  /**
   * Component constructor
   *
   * @param sanitizer: DomSanitizer
   */
  constructor(
    private dialog :MatDialog,
    private sanitizer :DomSanitizer,
    public notifSvc :NotificationService,
    private router :Router,
  ) {}

  ngOnInit() {}

  gotoPage(notif :any) {
    if (!notif.read_at) {
      this.notifSvc.markNotifRead(notif.id);
      notif.read_at = new Date();
    }

    if (notif.data.link) {
      this.router.navigateByUrl(notif.data.link + '/');

      return;
    }
    if (notif.data.payment_status) {
      if (notif.data.payment_status == 1) {
        this.router.navigateByUrl('/orders/pending-orders');
      } else {
        this.router.navigateByUrl('/orders/purchase-orders');
      }
    } else if (notif.data.po_number) {
      this.router.navigateByUrl('/orders/pending-orders');
    } else if (notif.data.updates && !notif.data.type) {
      this.router.navigateByUrl('/orders');
    } else if (notif.data.rfq_id) {
      let type = 'details';
      if (notif.data.type) {
        type = notif.data.type;
      } else if (notif.data.quotation_id) {
        type = 'quotations';
      }
      this.router.navigateByUrl('/quotes/' + notif.data.rfq_id + '/view?v=' + type);
    } else if (notif.data.kit_id) {
      this.router.navigateByUrl('/kits/' + notif.data.kit_id + '/view');
    } else if (notif.data.type === 'createPicklistPerOrder') {
      this.dialog.open(CreatedPicklistPerOrderNotificationsSummaryComponent, {
        width: DialogConfig.sizes.medium,
        data: notif,
      });
    } else if (
      notif.data.view_details &&
      notif.data.type === 'pulled_sales_order'
    ) {
      this.dialog.open(SalesOrderPullNotificationsComponent, {
        width: DialogConfig.sizes.medium,
        data: notif,
      });
    } else if (notif.data.type === 'purgatory_orders') {
      // Navigate to the purgatory page with a manually defined route
      const purgatoryUrl = '/shipping/purgatory';
      this.router.navigateByUrl(purgatoryUrl);
    } else {
      // this.router.navigateByUrl('/quotes/' + notif.data.rfq_id + '/quotations');
      this.router.navigateByUrl('/quotes/' + notif.data.rfq_id + '/view');
    }
  }

  backGroundStyle() :string {
    if (!this.bgImage) {
      return 'none';
    }

    return 'url(' + this.bgImage + ')';
  }
}
